import * as React from 'react';
import { cn } from '../../lib/utils';

/**
 * Loading spinner with accessible status announcement.
 * Uses role="status" and aria-label per FRONTEND_CONSOLE_GUIDE.md patterns.
 */
interface SpinnerProps {
  readonly className?: string;
  readonly label?: string;
}

export function Spinner({ className, label = 'Loading...' }: SpinnerProps): React.JSX.Element {
  return (
    <div className={cn('flex items-center justify-center gap-2', className)} role="status" aria-label={label}>
      <svg
        className="h-5 w-5 animate-spin text-primary"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
      </svg>
      <span className="text-sm text-muted-foreground">{label}</span>
    </div>
  );
}
